import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const StyledFaq = styled.div`
  overflow-x: hidden;

  .hero {
    width: calc(100vw - 80px);
    min-height: 400px;
    padding: 80px 40px;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    text-align: center;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;

   @media (max-width: ${breakpoints.medium}) {
      padding: 80px 20px
      width: calc(100vw - 40px)
    }
    .graphic{
      position: absolute;
      width: 100vw;
      height: 100%;
      opacity: 0.4;
      top:0;
      left:0;

    }

    .content {
      max-width: 900px;
      margin: 0 auto;

      h1 {
        font-size: 56px;
        line-height: 1.2;
        margin-bottom: 24px;
        color: var(--black);
      }

      p {
        font-size: 18px;
        color: var(--grey);
        line-height: 1.6;
      }
    }
  }

  .doc-cards {
    display: flex;
    gap: 20px;
    padding: 80px 40px;
    max-width: 1400px;
    margin: 0 auto;
    justify-content: space-between;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);

    .doc-card {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 24px;
      padding: 24px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: rgba(var(--greyr), 0.1);
        transform: translateY(-5px);
      }

      .doc-icon {
        flex-shrink: 0;
        color: var(--grey);
      }

      .doc-info {
        flex-grow: 1;
        h4 {
          font-size: 18px;
          margin-bottom: 8px;
        }
        p {
          font-size: 14px;
          color: var(--grey);
          line-height: 1.6;
        }
      }

      .doc-arrow {
        flex-shrink: 0;
        color: var(--grey);
        transition: transform 0.2s;
      }

      &:hover .doc-arrow {
        transform: translateX(5px);
      }
    }
  }


  .blog-section {
    padding: 80px 0;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    border-top: 1px solid rgba(var(--greyr), 0.3);

  }

  @media (max-width: 1024px) {
    .doc-cards {
      flex-direction: column;
    }
  }

  @media (max-width: 768px) {

    .contact-section .contact-content .contact-options {
      flex-direction: column;
      gap: 40px;
      align-items: center;
    }
  }
`;

export default StyledFaq;
